import { Form, Formik } from 'formik'
import { Modal } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Spinner } from 'common/Spinner/Spinner'
import { PostDaysField } from 'screens/Schedule/EditChannelsModal/PostDaysField'
import { PostTypeCountInput } from 'screens/Schedule/EditChannelsModal/PostTypeCountInput'
import { useCreditUsage } from 'hooks/useCreditUsage'
import { AvatarVideoAccounts } from './AvatarVideoAccounts'
import Styles from '../AiAvatarAnnouncementModal.module.scss'

export interface ScheduleConfig {
  count: number
  weekDays: string[]
  accountIds: number[]
}

interface Props {
  onBack: () => void
  onCommit: (config: ScheduleConfig) => void
  isCommitting: boolean
}

const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

const initialValues = {
  video_crosspost_contents: [{ type: 'post', count: 1, content_type: 'avatar_video', account_ids: [] as number[] }],
  week_days: WEEKDAYS,
}

export const ScheduleAvatarVideoStep = ({ onBack, onCommit, isCommitting }: Props) => {
  const { usageCosts } = useCreditUsage()
  const cost = usageCosts?.avatar_video_credits_cost ?? 0
  const handleSubmit = (values: typeof initialValues) => {
    const entry = values.video_crosspost_contents.find((content) => content.content_type === 'avatar_video')
    onCommit({
      count: entry?.count ?? 1,
      weekDays: values.week_days,
      accountIds: entry?.account_ids ?? [],
    })
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ submitForm }) => (
        <Modal.Root size="md">
          <Modal.Header
            title="When and where to post"
            subHeader={
              <Text variant="secondary" color="var(--dark-60)">
                We recommend starting with 1 video per week — {cost} credits/week. You can change this anytime.
              </Text>
            }
          />
          <Modal.Content>
            <Form className={Styles.scheduleForm}>
              <div className={Styles.scheduleControls}>
                <div className={Styles.field}>
                  <Heading level={5}>Days to post</Heading>
                  <PostDaysField />
                </div>
                <div className={Styles.field}>
                  <Heading level={5}>Posts per week</Heading>
                  <PostTypeCountInput
                    buttonVariant="secondary"
                    buttonSize="md"
                    size="md"
                    name="video_crosspost_contents"
                    postType="post"
                    contentType="avatar_video"
                    min={0}
                  />
                </div>
              </div>
              <AvatarVideoAccounts />
            </Form>
          </Modal.Content>
          <Modal.Footer>
            <Modal.FooterContent slot="left">
              <Button variant="tertiary" size="lg" onPress={onBack}>
                Back
              </Button>
            </Modal.FooterContent>
            <Modal.FooterContent slot="right">
              <Button variant="primary" size="lg" isDisabled={isCommitting} onPress={submitForm}>
                {isCommitting && <Spinner variant="transparent" className={Styles.spinner} />}
                Finish Setup
              </Button>
            </Modal.FooterContent>
          </Modal.Footer>
        </Modal.Root>
      )}
    </Formik>
  )
}
